import React from 'react';
import PropTypes from 'prop-types';

import Typography from '@material-ui/core/Typography';
import Card from '@material-ui/core/Card';
import Divider from '@material-ui/core/Divider';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import IndentedCardContent from '../IndentedCardContent/IndentedCardContent.js';
import DocumentStyleArea from '../DocumentStyleArea/DocumentStyleArea';

import { withStyles } from '@material-ui/core/styles';
import styles from './styles.js';

class ExpansionCard extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      hasBeenOpened: false,
    };

    this.handleFirstOpen = this.handleFirstOpen.bind(this);
  }

  handleFirstOpen() {
    const { openGAEvent } = this.props;

    const { hasBeenOpened } = this.state;

    // Ga event should only apply when a card is first openend.
    if (!hasBeenOpened && openGAEvent) {
      this.props.openGAEvent();
      this.setState({ hasBeenOpened: true });
    }
  }

  render() {
    const { classes, title, content, form, openGAEvent } = this.props;

    const Icon = this.props.icon;

    return (
      <Card className={`${classes.root} Card`}>
        <ExpansionPanel
          onChange={(event, expanded) => {
            expanded && this.handleFirstOpen();
          }}
        >
          <ExpansionPanelSummary
            expandIcon={<ExpandMoreIcon className={classes.chevron} />}
            classes={{
              root: classes.content,
              content: classes.expansionPanelSummaryContent,
              expanded: classes.expansionPanelSummaryExpanded,
              expandIcon: classes.expandIcon,
            }}
          >
            <Icon className={`${classes.avatarBase} ${classes.avatar}`} />
            <Typography className={classes.heading}>{title}</Typography>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails className={classes.expansionPanelDetails}>
            <IndentedCardContent
              body={
                <React.Fragment>
                  <Divider className={classes.divider} />
                  <div className={classes.contentContainer}>
                    {content && (
                      <Typography
                        className={classes.expansionPanelContent}
                        component="div"
                      >
                        <DocumentStyleArea content={content} />
                      </Typography>
                    )}
                  </div>
                  {form}
                </React.Fragment>
              }
            />
          </ExpansionPanelDetails>
        </ExpansionPanel>
      </Card>
    );
  }
}

ExpansionCard.propTypes = {
  classes: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  content: PropTypes.object,
  form: PropTypes.object,
  openGAEvent: PropTypes.func,
};

ExpansionCard.defaultProps = {
  content: null,
  form: null,
  openGAEvent: null,
};

export default withStyles(styles)(ExpansionCard);
